export const globalRouter = {
    navigate: null
  };
  